// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"4c8367c4","287":"275dddb3","453":"e460ce17","495":"faf04f4b","647":"04de7be6","654":"ef933717","669":"55a27017"}[chunkId] + ".chunk.js";
};